/* LOW PROFILE — theme runtime (progressive enhancement only) */
(function () {
  'use strict';

  // --- live HUD clock ------------------------------------------------------
  var pad = function (n) { return String(n).padStart(2, '0'); };
  function tick() {
    var now = new Date();
    var d = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear();
    var t = pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());
    document.querySelectorAll('[data-clock-date]').forEach(function (el) { el.textContent = d; });
    document.querySelectorAll('[data-clock-time]').forEach(function (el) { el.textContent = t; });
  }
  tick();
  setInterval(tick, 1000);

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SCROLL = reduceMotion ? 'auto' : 'smooth';

  // --- screen-reader announcements (one shared polite live region) ---------
  var live = document.createElement('div');
  live.className = 'sr-only';
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  function announce(msg) {
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50); // re-announce identical text
  }

  // --- mobile nav toggle ---------------------------------------------------
  var nav = document.querySelector('.nav');
  var toggle = document.querySelector('.nav__toggle');
  if (nav && toggle) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !nav.classList.contains('is-open')) return;
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    });
  }

  // --- contact modal -------------------------------------------------------
  // [data-contact-trigger] links (mailto fallback without JS) open the dialog.
  // Submit: relay endpoint verifies hCaptcha + posts to Discord; success swaps
  // the form for the confirmation line (no Shopify /contact post).
  var contact = document.querySelector('[data-contact-modal]');
  if (contact) (function () {
    var form = contact.querySelector('[data-contact-form]');
    var okEl = contact.querySelector('[data-contact-success]');
    var captchaBox = contact.querySelector('[data-contact-captcha]');
    var errEl = contact.querySelector('[data-contact-error]');
    var sitekey = contact.getAttribute('data-sitekey');
    var endpoint = contact.getAttribute('data-endpoint');
    var widget = null, opener = null, sending = false;
    var behind = [document.querySelector('.terminal'), document.querySelector('.skip-link')];

    // hCaptcha is third-party: only fetched once someone actually opens the form.
    function loadCaptcha() {
      if (!captchaBox || !sitekey || window.lpHcaptchaLoad) return;
      window.lpHcaptchaLoad = function () { widget = window.hcaptcha.render(captchaBox, { sitekey: sitekey, theme: 'dark' }); };
      var s = document.createElement('script');
      s.src = 'https://js.hcaptcha.com/1/api.js?render=explicit&onload=lpHcaptchaLoad';
      s.async = true;
      document.head.appendChild(s);
    }
    function openContact() {
      opener = document.activeElement;
      contact.hidden = false;
      document.body.style.overflow = 'hidden';
      behind.forEach(function (el) { if (el) el.inert = true; });
      loadCaptcha();
      (contact.querySelector('input') || contact.querySelector('[data-contact-close]')).focus();
    }
    function closeContact() {
      if (contact.hidden) return;
      contact.hidden = true;
      document.body.style.overflow = '';
      behind.forEach(function (el) { if (el) el.inert = false; });
      if (opener && opener.focus) opener.focus();
      opener = null;
    }
    function fail(msg) { errEl.textContent = msg; errEl.hidden = false; }

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-contact-trigger]')) return;
      e.preventDefault();
      openContact();
    });
    contact.addEventListener('click', function (e) { if (e.target === contact) closeContact(); });
    contact.querySelector('[data-contact-close]').addEventListener('click', closeContact);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeContact(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      errEl.hidden = true;
      var token = widget !== null && window.hcaptcha ? window.hcaptcha.getResponse(widget) : '';
      if (!token) return fail('COMPLETE THE CAPTCHA.');
      var btn = form.querySelector('[type="submit"]');
      sending = true;
      btn.disabled = true;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.elements['contact[name]'].value,
          email: form.elements['contact[email]'].value,
          message: form.elements['contact[body]'].value,
          website: form.elements.website.value,
          token: token,
        }),
      }).then(function (r) {
        if (!r.ok) throw new Error('relay ' + r.status);
        form.hidden = true;
        okEl.hidden = false;
        contact.querySelector('[data-contact-close]').focus();
      }).catch(function () {
        sending = false;
        btn.disabled = false;
        window.hcaptcha.reset(widget); // tokens are single-use
        fail('TRANSMISSION FAILED // RETRY.');
      });
    });
  })();

  // --- cart helpers (Shopify AJAX Cart API) --------------------------------
  // POST helpers that talk to the real cart; every caller falls back to a
  // visual-only update when the request fails (e.g. local dev has no backend).
  function setCartCount(n) {
    document.querySelectorAll('.nav__cart-label').forEach(function (label) {
      label.textContent = label.textContent.replace(/\[\d+\]/, '[' + n + ']');
    });
  }
  function bumpCartCount(delta) {
    var label = document.querySelector('.nav__cart-label');
    if (!label) return;
    var m = label.textContent.match(/\[(\d+)\]/);
    setCartCount(Math.max(0, (m ? parseInt(m[1], 10) : 0) + delta));
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') setCartCount(c.item_count); return c; });
  }
  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw e; });
      return r.json();
    });
  }
  refreshCartCount(); // seed nav count from the real cart on load

  // --- shuffled product grids ([data-shuffle]) -----------------------------
  // Fisher-Yates on the cards client-side (cached HTML can't vary per visit).
  document.querySelectorAll('[data-shuffle]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    cards.forEach(function (c) { grid.appendChild(c); });
  });

  // --- guide checklist: dropdown shows one row, reset shows all ([data-checklist])
  document.querySelectorAll('[data-checklist]').forEach(function (box) {
    var select = box.querySelector('[data-checklist-select]');
    var reset = box.querySelector('[data-checklist-reset]');
    var rows = Array.prototype.slice.call(box.querySelectorAll('tbody tr'));
    rows.forEach(function (row, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = row.cells[0].textContent;
      select.appendChild(opt);
    });
    function show(value) {
      rows.forEach(function (row, i) { row.hidden = value !== '' && String(i) !== value; });
      announce(value === '' ? rows.length + ' steps shown' : '1 step shown');
    }
    select.addEventListener('change', function () { show(select.value); });
    reset.addEventListener('click', function () { select.value = ''; show(''); select.focus(); });
    box.querySelector('[data-checklist-controls]').hidden = false;
  });

  // --- variant option pills ------------------------------------------------
  document.querySelectorAll('.opt__values').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var pill = e.target.closest('.opt__pill');
      if (!pill) return;
      group.querySelectorAll('.opt__pill').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
    });
  });

  // --- add-to-cart animation -----------------------------------------------
  // Label drops out, cart rolls in, payload drops in, check, cart rolls out,
  // label drops back. Resolves when finished (at once under reduced motion)
  // so callers can swap UI afterwards.
  var ATC_MS = 1600;
  var ATC_FX =
    '<span class="atc__fx" aria-hidden="true">' +
      '<span class="atc__ripple"></span>' +
      '<svg class="atc__cart" viewBox="0 0 24 24">' +
        '<path d="M2 4h3l2.4 10.5h11L21 7.5H6.2"/>' +
        '<circle cx="9" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>' +
        '<rect class="atc__item" x="10.5" y="7.5" width="4.5" height="4.5"/>' +
        '<path class="atc__check" d="M10 10.8l2 2 3.8-4"/>' +
      '</svg>' +
    '</span>';
  function playAddFx(btn, e) {
    if (reduceMotion) return Promise.resolve();
    if (!btn.querySelector('.atc__fx')) {
      var label = document.createElement('span');
      label.className = 'atc__label';
      while (btn.firstChild) label.appendChild(btn.firstChild);
      btn.appendChild(label);
      btn.insertAdjacentHTML('beforeend', ATC_FX);
      btn.classList.add('atc');
    }
    // ripple from the pointer; keyboard activation (detail 0) ripples from center
    var r = btn.getBoundingClientRect();
    var fromPointer = e && e.detail > 0 && e.clientX != null;
    btn.style.setProperty('--atc-x', fromPointer ? (e.clientX - r.left) + 'px' : '50%');
    btn.style.setProperty('--atc-y', fromPointer ? (e.clientY - r.top) + 'px' : '50%');
    btn.classList.remove('is-adding');
    void btn.offsetWidth; // restart the animation on rapid re-clicks
    btn.classList.add('is-adding');
    return new Promise(function (resolve) {
      setTimeout(function () { btn.classList.remove('is-adding'); resolve(); }, ATC_MS);
    });
  }

  // --- add to cart: PDP ----------------------------------------------------
  var buy = document.querySelector('.pdp__buy');
  if (buy) {
    var pdpVariants = [];
    var vjson = buy.querySelector('[data-pdp-variants]');
    if (vjson) { try { pdpVariants = JSON.parse(vjson.textContent) || []; } catch (e) { pdpVariants = []; } }
    var idField = buy.querySelector('input[name="id"]');

    // Match the active option pills (in order) against variant.option1/2/3.
    function syncVariant() {
      var groups = buy.querySelectorAll('.opt__values');
      if (!groups.length || !pdpVariants.length) return null;
      var chosen = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.opt__pill.is-active') || g.querySelector('.opt__pill');
        chosen.push({ pos: g.getAttribute('data-opt-position'), val: active ? active.getAttribute('data-value') : null });
      });
      var v = pdpVariants.find(function (variant) {
        return chosen.every(function (c) {
          return c.val == null || String(variant['option' + c.pos]) === String(c.val);
        });
      });
      if (v && idField) idField.value = v.id;
      return v || null;
    }
    buy.querySelectorAll('.opt__values').forEach(function (g) {
      g.addEventListener('click', function (e) { if (e.target.closest('.opt__pill')) syncVariant(); });
    });
    syncVariant();

    var submitBtn = buy.querySelector('button[type="submit"]');
    var lastClick = null; // pointer position for the add-to-cart ripple
    if (submitBtn) submitBtn.addEventListener('click', function (ev) { lastClick = ev; });

    buy.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = syncVariant();
      var id = (v && v.id) || (idField && idField.value);
      var added = buy.querySelector('.pdp__added');
      if (!id) return;
      var fx = submitBtn ? playAddFx(submitBtn, lastClick) : Promise.resolve();
      lastClick = null;
      var req = cartPost('/cart/add.js', { id: Number(id), quantity: 1 })
        .then(refreshCartCount)
        .catch(function () { bumpCartCount(1); }); // dev/offline fallback
      Promise.all([req, fx]).then(function () {
        if (added) added.hidden = false;
        announce('Added to cart');
      });
    });
  }

  // --- cart quantity steppers (visual) -------------------------------------
  // --- cart: quantity steppers, remove buttons, live totals ----------------
  (function cart() {
    var table = document.querySelector('.cart__table');
    if (!table) return;

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function recalc() {
      var rows = table.querySelectorAll('.cart__row:not(.cart__row--head)');
      var qtyTotal = 0, subtotal = 0;
      rows.forEach(function (r) {
        var b = r.querySelector('.cart__qty b');
        var qty = b ? parseInt(b.textContent, 10) : 1;
        if (isNaN(qty)) qty = 0;
        var unit = parseInt(r.dataset.unitPrice || '0', 10);
        var line = unit * qty;
        var amt = r.querySelector('.cart__amount');
        if (amt) amt.textContent = money(line);
        qtyTotal += qty;
        subtotal += line;
      });

      var sub = document.querySelector('.cart__subtotal');
      if (sub) sub.textContent = money(subtotal);
      var units = document.querySelector('[data-cart-units]');
      if (units) units.textContent = rows.length;
      var navLabel = document.querySelector('.nav__cart-label');
      if (navLabel) navLabel.textContent = navLabel.textContent.replace(/\[\d+\]/, '[' + qtyTotal + ']');

      if (rows.length === 0) showEmpty();
    }

    function showEmpty() {
      var section = document.querySelector('.cart');
      if (!section || section.querySelector('.cart__empty')) return;
      var t = section.querySelector('.cart__table');
      var f = section.querySelector('.cart__foot');
      if (t) t.remove();
      if (f) f.remove();
      var div = document.createElement('div');
      div.className = 'cart__empty';
      div.innerHTML = '<p>CART EMPTY // NO PAYLOAD</p>' +
        '<a class="btn" href="/collections/all">BROWSE PRODUCTS</a>';
      section.appendChild(div);
    }

    // Commit a line to an absolute quantity via the real cart, then re-render
    // from the server. Falls back to a visual-only update when there's no key
    // (local dev) or the request fails.
    table.querySelectorAll('.cart__row:not(.cart__row--head)').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var b = row.querySelector('.cart__qty b');
      var btns = row.querySelectorAll('.cart__qty button');
      var remove = row.querySelector('.cart__remove');

      function visual(n) {
        if (n <= 0) { row.remove(); } else if (b) { b.textContent = n; }
        recalc();
        announce(n <= 0 ? 'Removed from cart' : 'Quantity ' + n);
      }
      function commit(n) {
        if (!key) { visual(n); return; }
        cartPost('/cart/change.js', { id: key, quantity: n })
          .then(function () { window.location.reload(); })
          .catch(function () { visual(n); });
      }

      if (btns[0]) btns[0].addEventListener('click', function () { commit(Math.max(0, parseInt(b.textContent, 10) - 1)); });
      if (btns[1]) btns[1].addEventListener('click', function () { commit(parseInt(b.textContent, 10) + 1); });
      if (remove) remove.addEventListener('click', function () { commit(0); });
    });
  })();

  // --- feed normalization --------------------------------------------------
  // The upstream privacy feed returns { page, results:[...] }; the render code
  // wants { items:[...], page }. Normalize client-side (mirrors dev/server.js).
  // Passes through an already-normalized { items } payload (dev proxy / mock).
  function decodeEntities(s) {
    return String(s)
      .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"').replace(/&#0?39;/g, "'").replace(/&#x27;/g, "'");
  }
  function isUrl(u) { return typeof u === 'string' && /^https?:\/\//.test(u); }
  function feedRows(data) {
    if (!data) return null;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.results)) return data.results;
    return null;
  }
  function normalizeNews(data) {
    var rows = feedRows(data);
    if (!rows) return null;
    var items = rows.map(function (r) {
      return {
        title: typeof r.title === 'string' ? decodeEntities(r.title.trim()) : '',
        link: typeof r.link === 'string' ? r.link : '',
        feed: typeof r.feed === 'string' ? decodeEntities(r.feed.trim()) : '',
        image: isUrl(r.image) ? r.image : ''
      };
    }).filter(function (a) { return a.title && isUrl(a.link); });
    return { items: items, page: data.page || 0 };
  }
  function normalizePodcasts(data) {
    var rows = feedRows(data);
    if (!rows) return null;
    var items = rows.map(function (r) {
      return {
        title: typeof r.title === 'string' ? decodeEntities(r.title.trim()) : '',
        feed: typeof r.feed === 'string' ? decodeEntities(r.feed.trim()) : '',
        image: isUrl(r.image) ? r.image : '',
        media: isUrl(r.media) ? r.media : '',
        duration: typeof r.duration === 'number' && isFinite(r.duration) ? r.duration : 0,
        pub: typeof r.pub === 'number' && isFinite(r.pub) ? r.pub : 0,
        description: typeof r.description === 'string' ? decodeEntities(r.description.trim()) : '',
        link: typeof r.link === 'string' ? r.link : ''
      };
    }).filter(function (a) { return a.title && a.media; });
    return { items: items, page: data.page || 0 };
  }

  // --- live news feed ------------------------------------------------------
  // Progressive enhancement: sections ship empty shells with [data-news-*]
  // targets; we fetch the privacy feed and populate them. Render contract:
  // { items: [{ title, link, feed, image }] }.
  (function news() {
    var sections = document.querySelectorAll('[data-news]');
    if (!sections.length) return;

    var FALLBACK = [
      { title: 'ANTI-SURVEILLANCE / ADVERSARIAL FASHION', link: '', feed: 'LOW PROFILE' },
      { title: 'STAY LOW. MOVE FREE', link: '', feed: 'LOW PROFILE' },
      { title: 'WEAR LESS SIGNAL', link: '', feed: 'LOW PROFILE' },
      { title: 'PRIVACY LOOKS GOOD ON YOU', link: '', feed: 'LOW PROFILE' },
      { title: 'NO FACE // NO SIGNAL // NO TRACE', link: '', feed: 'LOW PROFILE' }
    ];

    function pad2(n) { return String(n).padStart(2, '0'); }

    // <a>/<span> wrapper for an item, with optional index + source tag.
    function itemNode(tag, item, opts) {
      opts = opts || {};
      var el = document.createElement(item.link ? 'a' : 'span');
      el.className = 'news__' + tag;
      if (item.link) {
        el.href = item.link;
        el.target = '_blank';
        el.rel = 'noopener noreferrer';
      }
      // faded thumbnail filling the card behind the text
      if (opts.thumb && item.image) {
        el.classList.add('has-thumb');
        var thumb = document.createElement('img');
        thumb.className = 'news__thumb';
        thumb.src = item.image;
        thumb.alt = '';
        thumb.loading = 'lazy';
        thumb.addEventListener('error', function () { el.classList.remove('has-thumb'); thumb.remove(); });
        el.appendChild(thumb);
      }
      if (opts.index != null) {
        var idx = document.createElement('span');
        idx.className = 'news__idx';
        idx.textContent = pad2(opts.index);
        el.appendChild(idx);
      }
      var body = document.createElement('span');
      body.className = 'news__body';
      var title = document.createElement('span');
      title.className = 'news__headline';
      title.textContent = item.title;
      body.appendChild(title);
      if (opts.showSrc !== false && item.feed) {
        var src = document.createElement('span');
        src.className = 'news__src';
        src.textContent = '[' + item.feed + ']';
        body.appendChild(src);
      }
      el.appendChild(body);
      return el;
    }

    function fill(container, items, build) {
      container.textContent = '';
      var count = parseInt(container.getAttribute('data-count'), 10) || items.length;
      var offset = parseInt(container.getAttribute('data-offset'), 10) || 0;
      for (var i = 0; i < count && offset + i < items.length; i++) {
        container.appendChild(build(items[offset + i], offset + i));
      }
    }

    function render(section, items) {
      if (!items.length) return;

      var breaking = section.querySelector('[data-news-breaking]');
      if (breaking) fill(breaking, items, function (item, i) {
        return itemNode('breaking-card', item, { index: i + 1, thumb: true });
      });

      var countEl = section.querySelector('[data-news-count]');
      if (countEl) countEl.textContent = items.length + (items.length === 1 ? ' ARTICLE' : ' ARTICLES');

      var lead = section.querySelector('[data-news-lead]');
      // The lead must always show an image: pick the first item that has one,
      // and drop it from the side list so nothing repeats.
      var leadItem = null;
      for (var li = 0; li < items.length; li++) {
        if (items[li].image) { leadItem = items[li]; break; }
      }
      if (!leadItem) leadItem = items[0];

      if (lead) {
        lead.textContent = '';
        lead.classList.toggle('is-link', !!leadItem.link);
        lead.classList.toggle('has-image', !!leadItem.image);
        if (leadItem.link) {
          lead.setAttribute('href', leadItem.link);
          lead.setAttribute('target', '_blank');
          lead.setAttribute('rel', 'noopener noreferrer');
          lead.removeAttribute('tabindex');
          lead.removeAttribute('aria-hidden');
        }
        if (leadItem.image) {
          var img = document.createElement('img');
          img.className = 'news__lead-img';
          img.src = leadItem.image;
          img.alt = '';
          img.loading = 'lazy';
          img.addEventListener('error', function () {
            lead.classList.remove('has-image');
            img.remove();
          });
          lead.appendChild(img);
        }
        var tag = document.createElement('span');
        tag.className = 'news__tag';
        tag.textContent = leadItem.feed || 'FEED';
        var h = document.createElement('span');
        h.className = 'news__lead-title';
        h.textContent = leadItem.title;
        lead.appendChild(tag);
        lead.appendChild(h);
      }

      var side = section.querySelector('[data-news-side]');
      if (side) {
        var rest = items.filter(function (x) { return x !== leadItem; });
        fill(side, rest, function (item, i) {
          return itemNode('side-row', item, { index: i + 2 });
        });
      }
      // grid is handled separately (paginated infinite scroll)
      initBreakingSlider(section);
    }

    // Horizontal slider for the breaking row: arrows page by one viewport width,
    // auto-hidden when the cards don't overflow. Idempotent — re-run per render.
    function initBreakingSlider(section) {
      var row = section.querySelector('[data-news-breaking]');
      if (!row) return;
      var prev = section.querySelector('[data-news-breaking-prev]');
      var next = section.querySelector('[data-news-breaking-next]');
      var pause = section.querySelector('[data-news-breaking-pause]');
      if (!prev || !next) return;
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
        var hasScroll = row.scrollWidth > row.clientWidth + 2;
        prev.hidden = next.hidden = !hasScroll;
        if (pause) pause.hidden = !hasScroll || reduceMotion;
        row.classList.toggle('is-end', !hasScroll || row.scrollLeft >= max);
      }
      row.__sliderSync = sync;
      if (!row.__sliderBound) {
        prev.addEventListener('click', function () { row.scrollBy({ left: -row.clientWidth, behavior: SCROLL }); });
        next.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth, behavior: SCROLL }); });
        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', function () { if (row.__sliderSync) row.__sliderSync(); }, { passive: true });

        // Auto-advance one page every 6s; loop at the end. Holds while hovered
        // or focused, stays off when the pause button is pressed, and never
        // starts under reduced motion.
        var hovered = false, focused = false, stopped = false;
        row.addEventListener('mouseenter', function () { hovered = true; });
        row.addEventListener('mouseleave', function () { hovered = false; });
        row.addEventListener('focusin', function () { focused = true; });
        row.addEventListener('focusout', function (e) { if (!row.contains(e.relatedTarget)) focused = false; });
        if (pause) pause.addEventListener('click', function () {
          stopped = !stopped;
          pause.setAttribute('aria-pressed', stopped ? 'true' : 'false');
          pause.innerHTML = stopped ? '&#9654;' : '&#10074;&#10074;';
        });
        if (!reduceMotion) setInterval(function () {
          if (hovered || focused || stopped) return;
          if (row.scrollWidth <= row.clientWidth + 2) return; // nothing to page
          var max = row.scrollWidth - row.clientWidth - 2;
          if (row.scrollLeft >= max) row.scrollTo({ left: 0, behavior: SCROLL });
          else row.scrollBy({ left: row.clientWidth, behavior: SCROLL });
        }, 6000);

        row.__sliderBound = true;
      }
      sync();
    }

    var src = sections[0].getAttribute('data-news-src') || '/api/news';
    function fetchPage(p) {
      var u = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'page=' + p;
      return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).then(normalizeNews);
    }

    function pad3(n) { return String(n).padStart(3, '0'); }

    // Cycled through, one per grid panel, in place of a static title.
    var FEED_TAGS = [
      'SURVEILLANCE', 'PRIVACY', 'ANONYMITY', 'ENCRYPTION', 'METADATA',
      'TRACKING', 'BIOMETRICS', 'FACIAL-REC', 'DRAGNET', 'DATA-BROKER',
      'ZERO-DAY', 'TELEMETRY', 'FINGERPRINT', 'DEEPFAKE', 'SPYWARE',
      'WIRETAP', 'DISINFO', 'BREACH', 'CENSORSHIP', 'SIGNALS',
      'REDACTED', 'BLACKOUT', 'COUNTERSURVEIL', 'EXFIL', 'NO-TRACE'
    ];

    // Build one lazygit-style panel for a page: `[NN] PRIVACY FEED` notched into
    // the top-left border, a grid of cards, and the card range in the bottom-right.
    function buildBlock(container, pageIndex, items) {
      var block = document.createElement('section');
      block.className = 'news__block';

      var head = document.createElement('div');
      head.className = 'section-head__left';
      var idx = document.createElement('span');
      idx.className = 'section-head__idx';
      idx.textContent = pad2(pageIndex + 1);
      var title = document.createElement('span');
      title.className = 'section-head__title';
      title.textContent = FEED_TAGS[pageIndex % FEED_TAGS.length];
      head.appendChild(idx); head.appendChild(title);

      var grid = document.createElement('div');
      grid.className = 'news__grid';
      var start = blockCount + 1;
      items.forEach(function (item) {
        blockCount += 1;
        grid.appendChild(itemNode('grid-card', item, { index: blockCount, thumb: true }));
      });

      var right = document.createElement('div');
      right.className = 'section-head__right';
      var range = document.createElement('span');
      range.textContent = pad3(start) + '–' + pad3(blockCount);
      right.appendChild(range);

      block.appendChild(head);
      block.appendChild(grid);
      block.appendChild(right);
      container.appendChild(block);
    }

    var blockCount = 0;

    // Paginated feed. Page 1 is page=0. Each page becomes its own lazygit panel
    // (news__block) of 48; card numbering continues across panels.
    function initInfiniteGrid(container, firstItems) {
      var page = 0, loading = false, done = false;
      buildBlock(container, 0, firstItems);

      // Load the next page when the scroll reaches (or passes) the bottom of the
      // content. Checked on every scroll, so it keeps firing as the user scrolls
      // further; the initial 48 posts load without any fetch.
      function nearBottom() {
        var doc = document.documentElement;
        var scrolled = (window.scrollY || window.pageYOffset || doc.scrollTop || 0) + window.innerHeight;
        return scrolled >= doc.scrollHeight - 500;
      }
      function stop() {
        done = true;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
      function loadMore() {
        if (loading || done) return;
        loading = true;
        page += 1;
        fetchPage(page).then(function (d) {
          loading = false;
          if (!(d && Array.isArray(d.items) && d.items.length)) { stop(); return; }
          buildBlock(container, page, d.items);
          if (page >= 40) stop(); // safety cap
          else if (nearBottom()) loadMore(); // still short — keep filling
        }).catch(function () { loading = false; });
      }
      function onScroll() { if (nearBottom()) loadMore(); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    // Render fallback immediately so the breaking/featured shells are never
    // empty, then fetch. The paginated feed grid fills once page 0 arrives.
    sections.forEach(function (s) { render(s, FALLBACK); });

    fetchPage(0)
      .then(function (d) {
        if (!(d && Array.isArray(d.items) && d.items.length)) return;
        sections.forEach(function (s) { render(s, d.items); });
        var container = document.querySelector('[data-news-grid]');
        if (container) initInfiniteGrid(container, d.items);
      })
      .catch(function () { /* keep fallback */ });
  })();

  // --- product card add-to-cart (grid + bento) -----------------------------
  // Same toggle as the bento. When the product has multi-value options, a size
  // selector shows below ADD TO CART; a selection is required before adding.
  document.querySelectorAll('[data-card-cart]').forEach(function (box) {
    var add = box.querySelector('.card__add');
    var bar = box.querySelector('.card__bar');
    var qtyEl = box.querySelector('.card__qty b');
    var dec = box.querySelector('[data-dec]');
    var inc = box.querySelector('[data-inc]');
    var optsWrap = box.querySelector('[data-card-opts]');
    if (!add || !bar || !qtyEl) return;

    var variants = [];
    var vjson = box.querySelector('[data-card-variants]');
    if (vjson) { try { variants = JSON.parse(vjson.textContent) || []; } catch (e) { variants = []; } }

    if (optsWrap) {
      optsWrap.querySelectorAll('.card__opts').forEach(function (g) {
        g.addEventListener('click', function (e) {
          var p = e.target.closest('.card__opt');
          if (!p) return;
          g.querySelectorAll('.card__opt').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          p.classList.add('is-active');
          p.setAttribute('aria-pressed', 'true');
          box.classList.remove('is-invalid');
        });
      });
    }

    // Resolve the chosen variant id (null if a required option is unselected).
    function resolveId() {
      if (!optsWrap) return Number(add.getAttribute('data-variant-id')) || null;
      var groups = optsWrap.querySelectorAll('.card__opts');
      var complete = true;
      var match = variants.filter(function (v) {
        return Array.prototype.every.call(groups, function (g) {
          var a = g.querySelector('.card__opt.is-active');
          if (!a) { complete = false; return false; }
          return String(v['option' + g.getAttribute('data-opt-position')]) === String(a.getAttribute('data-value'));
        });
      });
      if (!complete) return null;
      return match.length ? match[0].id : null;
    }

    var lineId = null;
    function qty() { return parseInt(qtyEl.textContent, 10) || 1; }
    function change(n) {
      if (!lineId) return Promise.reject();
      return cartPost('/cart/change.js', { id: lineId, quantity: n }).then(refreshCartCount);
    }

    add.addEventListener('click', function (e) {
      if (add.disabled || add.classList.contains('is-adding')) return;
      var id = resolveId();
      if (!id) { box.classList.add('is-invalid'); announce('Choose a size first'); return; } // size required
      lineId = id;
      var fx = playAddFx(add, e);
      var req = cartPost('/cart/add.js', { id: id, quantity: qty() }).then(refreshCartCount)
        .catch(function () { bumpCartCount(qty()); }); // dev/offline fallback
      Promise.all([req, fx]).then(function () {
        add.hidden = true; if (optsWrap) optsWrap.hidden = true; bar.hidden = false;
        announce('Added to cart');
        if (document.activeElement === document.body || document.activeElement === add) inc.focus(); // keep focus off the now-hidden button
      });
    });
    dec.addEventListener('click', function () {
      if (bar.hidden) return;
      var n = qty();
      if (n <= 1) {
        change(0).catch(function () { bumpCartCount(-1); })
                 .then(function () {
                   bar.hidden = true; add.hidden = false; if (optsWrap) optsWrap.hidden = false;
                   add.focus(); // the focused − button just disappeared
                   announce('Removed from cart');
                 });
        return;
      }
      qtyEl.textContent = n - 1;
      announce('Quantity ' + (n - 1));
      change(n - 1).catch(function () { bumpCartCount(-1); });
    });
    inc.addEventListener('click', function () {
      if (bar.hidden) return;
      var n = qty() + 1;
      qtyEl.textContent = n;
      announce('Quantity ' + n);
      change(n).catch(function () { bumpCartCount(1); });
    });
  });

  // --- privacy podcasts + floating audio player ----------------------------
  (function podcasts() {
    var section = document.querySelector('[data-podcasts]');
    if (!section) return;
    var row = section.querySelector('[data-podcasts-row]');
    var countEl = section.querySelector('[data-podcasts-count]');
    var src = section.getAttribute('data-podcasts-src') || '/api/podcasts';

    function fmtDur(sec) {
      var m = Math.max(1, Math.round((sec || 0) / 60));
      if (m >= 60) { return Math.floor(m / 60) + 'H ' + (m % 60) + 'M'; }
      return m + ' MIN';
    }
    function clock(sec) {
      sec = Math.max(0, Math.floor(sec || 0));
      return Math.floor(sec / 60) + ':' + String(sec % 60).padStart(2, '0');
    }
    // relative "time ago" from a unix timestamp (seconds)
    function timeAgo(pub) {
      if (!pub) return '';
      var s = Math.floor(Date.now() / 1000) - pub;
      if (s < 0) s = 0;
      if (s < 60) return 'JUST NOW';
      var m = Math.floor(s / 60); if (m < 60) return m + 'M AGO';
      var h = Math.floor(m / 60); if (h < 24) return h + 'H AGO';
      var d = Math.floor(h / 24); if (d < 7) return d + 'D AGO';
      var w = Math.floor(d / 7); if (w < 5) return w + 'W AGO';
      var mo = Math.floor(d / 30.44); if (mo < 12) return mo + 'MO AGO';
      return Math.floor(d / 365) + 'Y AGO';
    }
    function svg(p) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + p + '</svg>'; }
    var ICON = {
      play: svg('<path d="M8 5v14l11-7z"/>'),
      pause: svg('<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>'),
      rew: svg('<path d="M11 6v12L2 12zM22 6v12l-9-6z"/>'),
      fwd: svg('<path d="M2 6v12l9-6zM13 6v12l9-6z"/>'),
      vol: svg('<path d="M3 9v6h4l5 4V5L7 9z"/><path d="M16 8.5c1.8 2 1.8 5 0 7" fill="none" stroke="currentColor" stroke-width="1.8"/>'),
      mute: svg('<path d="M3 9v6h4l5 4V5L7 9z"/><path d="M16 9l5 6M21 9l-5 6" fill="none" stroke="currentColor" stroke-width="1.8"/>'),
      close: svg('<path d="M6 6l12 12M18 6L6 18"/>')
    };

    var player, audio, els = {};
    function buildPlayer() {
      player = document.createElement('div');
      player.className = 'podcast-container';
      player.hidden = true;
      player.innerHTML =
        '<div class="podcast-container__image"><img alt=""></div>' +
        '<button class="podcast-container__close" aria-label="Close player" title="Close">' + ICON.close + '</button>' +
        '<div class="podcast-container__header">' +
          '<div class="podcast-container__header--image"><img alt=""></div>' +
          '<div class="podcast-container__header--details">' +
            '<span class="pod__post--series" data-p-feed></span>' +
            '<h2 class="pod__post--title" data-p-title></h2>' +
          '</div>' +
        '</div>' +
        '<div class="podcast-controls">' +
          '<button class="pc-btn" data-p-rew aria-label="Rewind 5 seconds">' + ICON.rew + '</button>' +
          '<button class="pc-btn pc-play" data-p-play aria-label="Play">' + ICON.play + '</button>' +
          '<button class="pc-btn" data-p-fwd aria-label="Forward 15 seconds">' + ICON.fwd + '</button>' +
          '<span class="pc-time" data-p-cur>0:00</span>' +
          '<input class="pc-seek" type="range" min="0" max="1000" value="0" aria-label="Seek">' +
          '<span class="pc-time" data-p-dur>0:00</span>' +
          '<button class="pc-btn" data-p-vol aria-label="Mute">' + ICON.vol + '</button>' +
        '</div>' +
        '<audio preload="metadata"></audio>';
      document.body.appendChild(player);
      audio = player.querySelector('audio');
      els.bg = player.querySelector('.podcast-container__image img');
      els.cover = player.querySelector('.podcast-container__header--image img');
      els.feed = player.querySelector('[data-p-feed]');
      els.title = player.querySelector('[data-p-title]');
      els.play = player.querySelector('[data-p-play]');
      els.cur = player.querySelector('[data-p-cur]');
      els.dur = player.querySelector('[data-p-dur]');
      els.seek = player.querySelector('.pc-seek');
      els.vol = player.querySelector('[data-p-vol]');
      var seeking = false;

      player.querySelector('.podcast-container__close').addEventListener('click', closePlayer);
      els.play.addEventListener('click', function () { if (audio.paused) audio.play(); else audio.pause(); });
      player.querySelector('[data-p-rew]').addEventListener('click', function () { audio.currentTime = Math.max(0, audio.currentTime - 5); });
      player.querySelector('[data-p-fwd]').addEventListener('click', function () { audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 15); });
      els.vol.addEventListener('click', function () { audio.muted = !audio.muted; els.vol.innerHTML = audio.muted ? ICON.mute : ICON.vol; });
      els.seek.addEventListener('input', function () { seeking = true; });
      els.seek.addEventListener('change', function () { if (audio.duration) audio.currentTime = (els.seek.value / 1000) * audio.duration; seeking = false; });
      audio.addEventListener('play', function () { els.play.innerHTML = ICON.pause; els.play.setAttribute('aria-label', 'Pause'); });
      audio.addEventListener('pause', function () { els.play.innerHTML = ICON.play; els.play.setAttribute('aria-label', 'Play'); });
      audio.addEventListener('loadedmetadata', function () { els.dur.textContent = clock(audio.duration); });
      audio.addEventListener('timeupdate', function () {
        els.cur.textContent = clock(audio.currentTime);
        els.seek.setAttribute('aria-valuetext', clock(audio.currentTime) + ' of ' + clock(audio.duration));
        if (!seeking && audio.duration) els.seek.value = String(Math.round(audio.currentTime / audio.duration * 1000));
      });
      audio.addEventListener('ended', closePlayer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !player.hidden) closePlayer(); });
    }
    function clearActive() {
      var a = document.querySelector('.pod__post.is-playing');
      if (a) a.classList.remove('is-playing');
    }
    function closePlayer() {
      if (!player) return;
      audio.pause(); audio.removeAttribute('src'); audio.load();
      player.hidden = true; clearActive();
    }
    function playItem(item, cardEl) {
      if (!player) buildPlayer();
      els.feed.textContent = item.feed || '';
      els.title.textContent = item.title || '';
      if (item.image) { els.cover.src = item.image; els.bg.src = item.image; }
      audio.src = item.media;
      player.hidden = false;
      announce('Now playing: ' + (item.title || 'episode') + (item.feed ? ', ' + item.feed : ''));
      clearActive();
      if (cardEl) cardEl.classList.add('is-playing');
      var p = audio.play(); if (p && p.catch) p.catch(function () {});
    }

    function makeCard(item) {
      var el = document.createElement('div');
      el.className = 'pod__post';
      el.innerHTML =
        '<button type="button" class="card-hit"></button>' +
        '<div class="pod__post--image">' +
          '<img class="pod__cover" loading="lazy" alt="" hidden>' +
          '<span class="pod__post--play" aria-hidden="true">' + ICON.play + '</span>' +
          '<span class="pod__post--badge">' + fmtDur(item.duration) + '</span>' +
        '</div>' +
        '<div class="pod__post--content">' +
          '<div class="pod__post--title"></div>' +
          '<div class="pod__post--series"></div>' +
          '<div class="pod__post--date"></div>' +
        '</div>';
      if (item.image) { var cov = el.querySelector('.pod__cover'); cov.src = item.image; cov.hidden = false; }
      el.querySelector('.pod__post--title').textContent = item.title;
      el.querySelector('.pod__post--series').textContent = item.feed || 'UNKNOWN';
      var ago = timeAgo(item.pub);
      var dateEl = el.querySelector('.pod__post--date');
      if (ago) dateEl.textContent = ago; else dateEl.remove();
      el.querySelector('.card-hit').setAttribute('aria-label', 'Play episode: ' + item.title + (item.feed ? ', ' + item.feed : ''));
      el.addEventListener('click', function () { playItem(item, el); });
      return el;
    }

    // horizontal slider: arrows page by ~5 cards (one viewport width)
    function initSlider() {
      var prev = section.querySelector('[data-podcasts-prev]');
      var next = section.querySelector('[data-podcasts-next]');
      if (!prev || !next) return;
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
        var hasScroll = row.scrollWidth > row.clientWidth + 2;
        prev.hidden = next.hidden = !hasScroll;
        row.classList.toggle('is-end', !hasScroll || row.scrollLeft >= max);
      }
      prev.addEventListener('click', function () { row.scrollBy({ left: -row.clientWidth, behavior: SCROLL }); });
      next.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth, behavior: SCROLL }); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    // --- podcasts page: paginated infinite grid (mirrors the news page) -----
    function pad2p(n) { return String(n).padStart(2, '0'); }
    function pad3p(n) { return String(n).padStart(3, '0'); }
    function fetchPodPage(p) {
      var u = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'page=' + p;
      return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).then(normalizePodcasts);
    }
    var podCount = 0;
    function buildPodBlock(container, pageIndex, items) {
      var block = document.createElement('section');
      block.className = 'news__block';
      var head = document.createElement('div');
      head.className = 'section-head__left';
      var idx = document.createElement('span');
      idx.className = 'section-head__idx';
      idx.textContent = pad2p(pageIndex + 1);
      var title = document.createElement('span');
      title.className = 'section-head__title';
      title.textContent = 'EPISODES';
      head.appendChild(idx); head.appendChild(title);
      var grid = document.createElement('div');
      grid.className = 'podcasts__grid';
      var start = podCount + 1;
      items.forEach(function (it) { podCount += 1; grid.appendChild(makeCard(it)); });
      var right = document.createElement('div');
      right.className = 'section-head__right';
      var range = document.createElement('span');
      range.textContent = pad3p(start) + '–' + pad3p(podCount);
      right.appendChild(range);
      block.appendChild(head); block.appendChild(grid); block.appendChild(right);
      container.appendChild(block);
    }
    function initPodInfiniteGrid(container, firstItems) {
      var page = 0, loading = false, done = false;
      buildPodBlock(container, 0, firstItems);
      function nearBottom() {
        var doc = document.documentElement;
        var scrolled = (window.scrollY || window.pageYOffset || doc.scrollTop || 0) + window.innerHeight;
        return scrolled >= doc.scrollHeight - 500;
      }
      function stop() {
        done = true;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
      function loadMore() {
        if (loading || done) return;
        loading = true;
        page += 1;
        fetchPodPage(page).then(function (d) {
          loading = false;
          if (!(d && Array.isArray(d.items) && d.items.length)) { stop(); return; }
          buildPodBlock(container, page, d.items);
          if (page >= 40) stop();
          else if (nearBottom()) loadMore();
        }).catch(function () { loading = false; });
      }
      function onScroll() { if (nearBottom()) loadMore(); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    var grid = section.querySelector('[data-podcasts-grid]');
    if (grid) {
      fetchPodPage(0).then(function (d) {
        if (!(d && Array.isArray(d.items) && d.items.length)) { section.hidden = true; return; }
        initPodInfiniteGrid(grid, d.items);
      }).catch(function () { section.hidden = true; });
      return;
    }

    // homepage: single-fetch horizontal slider
    fetch(src).then(function (r) { return r.ok ? r.json() : null; }).then(normalizePodcasts).then(function (d) {
      if (!(d && Array.isArray(d.items) && d.items.length)) { section.hidden = true; return; }
      row.textContent = '';
      d.items.forEach(function (it) { row.appendChild(makeCard(it)); });
      if (countEl) countEl.textContent = d.items.length + (d.items.length === 1 ? ' EPISODE' : ' EPISODES');
      initSlider();
    }).catch(function () { section.hidden = true; });
  })();

  // --- videos: youtube feed, hover preview, fullscreen modal ---------------
  (function videos() {
    var section = document.querySelector('[data-videos]');
    if (!section) return;
    var grid = section.querySelector('[data-videos-grid]');
    var row = section.querySelector('[data-videos-row]');
    var countEl = section.querySelector('[data-videos-count]');
    if (!grid && !row) return;
    var src = section.getAttribute('data-videos-src') || '/api/videos';
    var CH_CDN = 'https://startyparty.nyc3.cdn.digitaloceanspaces.com/channels/';
    var ICONPLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';

    function pad2(n) { return String(n).padStart(2, '0'); }
    function pad3(n) { return String(n).padStart(3, '0'); }
    function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function fmtDur(sec) {
      sec = Math.max(0, Math.floor(sec || 0));
      var m = Math.floor(sec / 60), s = sec % 60;
      if (m >= 60) return Math.floor(m / 60) + ':' + pad2(m % 60) + ':' + pad2(s);
      return m + ':' + pad2(s);
    }
    function timeAgo(pub) {
      if (!pub) return '';
      var s = Math.floor(Date.now() / 1000) - pub; if (s < 0) s = 0;
      if (s < 60) return 'JUST NOW';
      var m = Math.floor(s / 60); if (m < 60) return m + 'M AGO';
      var h = Math.floor(m / 60); if (h < 24) return h + 'H AGO';
      var d = Math.floor(h / 24); if (d < 7) return d + 'D AGO';
      var w = Math.floor(d / 7); if (w < 5) return w + 'W AGO';
      var mo = Math.floor(d / 30.44); if (mo < 12) return mo + 'MO AGO';
      return Math.floor(d / 365) + 'Y AGO';
    }

    function normalize(data) {
      var rows = data && (Array.isArray(data.items) ? data.items : (Array.isArray(data.results) ? data.results : null));
      if (!rows) return null;
      var items = rows.map(function (r) {
        return {
          id: r.id || '',
          title: typeof r.title === 'string' ? r.title : '',
          channel: r.channel || '',
          channel_id: r.channel_id || '',
          duration: typeof r.duration === 'number' ? r.duration : 0,
          pub: typeof r.pub === 'number' ? r.pub : 0
        };
      }).filter(function (v) { return v.id && v.title && !/\[private video\]/i.test(v.title); });
      return { items: items, page: data.page || 0 };
    }
    function fetchPage(p) {
      var u = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'page=' + p;
      return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).then(normalize);
    }

    // fullscreen modal player (video max-width 1800px, 16:9); ESC or click-out closes.
    var modal, opener;
    function buildModal() {
      modal = document.createElement('div');
      modal.className = 'video-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'video-modal-title');
      modal.innerHTML =
        '<div class="video-modal__panel">' +
          '<div class="section-head__left">' +
            '<span class="section-head__idx">▶</span>' +
            '<span class="section-head__title" id="video-modal-title" data-vm-title></span>' +
          '</div>' +
          '<button class="video-modal__close" aria-label="Close">&times;</button>' +
          '<div class="video-modal__frame"></div>' +
        '</div>';
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      modal.querySelector('.video-modal__close').addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });
      document.body.appendChild(modal);
    }
    function openModal(item) {
      if (!modal) buildModal();
      modal.querySelector('[data-vm-title]').textContent = item.title || '';
      modal.querySelector('.video-modal__frame').innerHTML =
        '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(item.id) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="' + esc(item.title) + '" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      // everything behind the dialog goes inert: keeps Tab and screen readers inside
      opener = document.activeElement;
      Array.prototype.forEach.call(document.body.children, function (c) { if (c !== modal && c !== live) c.inert = true; });
      modal.querySelector('.video-modal__close').focus();
    }
    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.querySelector('.video-modal__frame').innerHTML = '';
      modal.hidden = true;
      document.body.style.overflow = '';
      Array.prototype.forEach.call(document.body.children, function (c) { c.inert = false; });
      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    function makeCard(item) {
      var el = document.createElement('article');
      el.className = 'video';
      var thumb = 'https://i.ytimg.com/vi/' + item.id + '/mqdefault.jpg';
      el.innerHTML =
        '<button type="button" class="card-hit" aria-label="' + esc(item.title ? 'Play video: ' + item.title : 'Play video') + '"></button>' +
        '<div class="video__post--image">' +
          '<img class="video__thumb" src="' + thumb + '" alt="" loading="lazy">' +
          (item.duration ? '<span class="video__post--duration">' + fmtDur(item.duration) + '</span>' : '') +
          '<span class="video__post--play" aria-hidden="true">' + ICONPLAY + '</span>' +
        '</div>' +
        '<div class="video__post--content">' +
          '<div class="video__post--meta">' +
            (item.channel_id ? '<img class="video__post--icon" src="' + CH_CDN + encodeURIComponent(item.channel_id) + '.webp" alt="" loading="lazy">' : '') +
            '<span class="video__post--category">' + esc(item.channel) + '</span>' +
            (timeAgo(item.pub) ? '<span class="video__post--date">' + timeAgo(item.pub) + '</span>' : '') +
          '</div>' +
          '<h2 class="video__post--title">' + esc(item.title) + '</h2>' +
        '</div>';
      var icon = el.querySelector('.video__post--icon');
      if (icon) icon.addEventListener('error', function () { icon.remove(); });

      // hover: muted autoplay preview iframe over the thumbnail
      var imgWrap = el.querySelector('.video__post--image');
      var preview;
      el.addEventListener('mouseenter', function () {
        if (preview || reduceMotion) return;
        preview = document.createElement('iframe');
        preview.className = 'video__preview';
        preview.src = 'https://www.youtube.com/embed/' + encodeURIComponent(item.id) + '?autoplay=1&mute=1&playsinline=1&controls=0&modestbranding=1&rel=0';
        preview.setAttribute('frameborder', '0');
        preview.setAttribute('allow', 'autoplay; encrypted-media');
        imgWrap.appendChild(preview);
      });
      function clearPreview() { if (preview) { preview.remove(); preview = null; } }
      el.addEventListener('mouseleave', clearPreview);
      el.addEventListener('click', function () { clearPreview(); openModal(item); });
      return el;
    }

    var VID_TAGS = ['SURVEILLANCE', 'PRIVACY', 'ANONYMITY', 'ENCRYPTION', 'TRACKING', 'BIOMETRICS', 'FACIAL-REC', 'DRAGNET', 'SIGNALS', 'COUNTERSURVEIL'];
    var vidCount = 0;
    function buildBlock(container, pageIndex, items) {
      var block = document.createElement('section');
      block.className = 'news__block';
      var head = document.createElement('div');
      head.className = 'section-head__left';
      var idx = document.createElement('span');
      idx.className = 'section-head__idx';
      idx.textContent = pad2(pageIndex + 1);
      var title = document.createElement('span');
      title.className = 'section-head__title';
      title.textContent = VID_TAGS[pageIndex % VID_TAGS.length];
      head.appendChild(idx); head.appendChild(title);
      var g = document.createElement('div');
      g.className = 'videos__grid';
      var start = vidCount + 1;
      items.forEach(function (it) { vidCount += 1; g.appendChild(makeCard(it)); });
      var right = document.createElement('div');
      right.className = 'section-head__right';
      var range = document.createElement('span');
      range.textContent = pad3(start) + '–' + pad3(vidCount);
      right.appendChild(range);
      block.appendChild(head); block.appendChild(g); block.appendChild(right);
      container.appendChild(block);
    }
    function initInfinite(container, firstItems) {
      var page = 0, loading = false, done = false;
      buildBlock(container, 0, firstItems);
      function nearBottom() {
        var doc = document.documentElement;
        var s = (window.scrollY || window.pageYOffset || doc.scrollTop || 0) + window.innerHeight;
        return s >= doc.scrollHeight - 500;
      }
      function stop() {
        done = true;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
      function loadMore() {
        if (loading || done) return;
        loading = true;
        page += 1;
        fetchPage(page).then(function (d) {
          loading = false;
          if (!(d && d.items && d.items.length)) { stop(); return; }
          buildBlock(container, page, d.items);
          if (page >= 40) stop();
          else if (nearBottom()) loadMore();
        }).catch(function () { loading = false; });
      }
      function onScroll() { if (nearBottom()) loadMore(); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      // Kick pagination if the first page doesn't fill the viewport (nothing to scroll).
      requestAnimationFrame(function () { if (nearBottom()) loadMore(); });
    }

    // homepage: horizontal slider (arrows page by one viewport width)
    function initSlider() {
      var prev = section.querySelector('[data-videos-prev]');
      var next = section.querySelector('[data-videos-next]');
      if (!prev || !next) return;
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
        var has = row.scrollWidth > row.clientWidth + 2;
        prev.hidden = next.hidden = !has;
        row.classList.toggle('is-end', !has || row.scrollLeft >= max);
      }
      prev.addEventListener('click', function () { row.scrollBy({ left: -row.clientWidth, behavior: SCROLL }); });
      next.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth, behavior: SCROLL }); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    if (grid) {
      // videos page: paginated infinite grid
      fetchPage(0).then(function (d) {
        if (!(d && d.items && d.items.length)) { section.hidden = true; return; }
        initInfinite(grid, d.items);
      }).catch(function () { section.hidden = true; });
      return;
    }

    // homepage: single-fetch slider
    fetchPage(0).then(function (d) {
      if (!(d && d.items && d.items.length)) { section.hidden = true; return; }
      d.items.forEach(function (it) { row.appendChild(makeCard(it)); });
      if (countEl) countEl.textContent = d.items.length + (d.items.length === 1 ? ' VIDEO' : ' VIDEOS');
      initSlider();
    }).catch(function () { section.hidden = true; });
  })();

  // --- hero surveillance shader (WebGL, procedural, black & white) ----------
  // CRT "camera acquiring target" effect: roaming detection reticles over a
  // grainy monochrome feed. Bezel/border, LED and green phosphor removed;
  // the iChannel texture feedback is replaced with procedural value-noise so
  // the page stays fully offline (no textures, no libraries).
  (function heroShader() {
    var canvas = document.querySelector('.hero__canvas');
    if (!canvas) return;
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return;

    var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';

    var FS = [
      'precision highp float;',
      'uniform vec2 iResolution;',
      'uniform float iTime;',
      '',
      '#define DETECT_BLINK 1.5',
      '#define DETECT_BORDER 4.0',
      '#define DETECT_CROSS 8.0',
      '#define DETECT_SEQUENCE 10.0',
      '',
      'float hash(float n){ return fract(sin(n)*43758.5453); }',
      'float hash2(vec2 p){ return fract(sin(dot(p, vec2(127.1,311.7)))*43758.5453); }',
      'float roundBox(vec2 p, vec2 b, float r){ return length(max(abs(p)-b,0.0))-r; }',
      'float signal(float v){ v -= floor(v); return v < 0.5 ? 0.0 : 1.0; }',
      'float vnoise(vec2 x){',
      '  vec2 i=floor(x), f=fract(x);',
      '  float a=hash2(i), b=hash2(i+vec2(1.0,0.0)), c=hash2(i+vec2(0.0,1.0)), d=hash2(i+vec2(1.0,1.0));',
      '  vec2 u=f*f*(3.0-2.0*f);',
      '  return mix(mix(a,b,u.x), mix(c,d,u.x), u.y);',
      '}',
      '',
      'vec3 getPixel(vec2 p){',
      '  p.y *= iResolution.y / iResolution.x;',
      '  p *= 0.425;',
      '  vec2 trans = vec2(iTime)*vec2(0.0331,0.0051);',
      '  int detectID = int(iTime / DETECT_SEQUENCE);',
      '  float detectTime = mod(iTime, DETECT_SEQUENCE);',
      '  vec2 center = vec2(hash(float(detectID)), hash(float(detectID)*1500.0))*2.0-1.0;',
      '  center.x *= 0.3; center.y *= 0.1;',
      '  center -= vec2(mod(trans.x,0.8)-0.4, mod(trans.y,0.4)-0.2);',
      '  if (detectTime < DETECT_BLINK){',
      '    if (signal(detectTime*5.0) < 0.5){',
      '      if (roundBox(p-center, vec2(0.001), 0.0) < 0.005) return vec3(1.0);',
      '    }',
      '  } else if (detectTime < DETECT_BORDER){',
      '    float g = (detectTime-DETECT_BLINK)/(DETECT_BORDER-DETECT_BLINK);',
      '    vec2 q = p-center; float r = length(q);',
      '    if (abs(r - g*0.054) < 0.0016) return vec3(1.0);',
      '  } else if (detectTime < DETECT_CROSS){',
      '    vec2 q = p-center; float r = length(q); float a = atan(q.y, q.x);',
      '    if (roundBox(q, vec2(100.0,0.0018), 0.0) < 0.0006) return vec3(1.0);',
      '    if (roundBox(q, vec2(0.0018,100.0), 0.0) < 0.0006) return vec3(1.0);',
      '    if (r < 0.060){',
      '      if (abs(r-0.020) < 0.0014) return vec3(1.0);',
      '      if (abs(r-0.038) < 0.0014) return vec3(1.0);',
      '      if (abs(r-0.054) < 0.0014) return vec3(1.0);',
      '      if (r > 0.004 && abs(sin(4.0*a))*r < 0.001) return vec3(1.0);',
      '      if (r < 0.005) return vec3(1.0);',
      '    }',
      '  }',
      '  // procedural monochrome camera static',
      '  p += trans;',
      '  float n = vnoise(p*7.0 + trans*4.0);',
      '  n += 0.5*vnoise(p*15.0 - iTime*0.05);',
      '  n = clamp(n, 0.0, 1.0);',
      '  return vec3(pow(n, 1.6) * 0.6);',
      '}',
      '',
      'vec3 getScreen(vec2 p){',
      '  float scanline = sqrt(sin(p.y*3.1415*110.0)*0.5+0.5);',
      '  float glitch = sin(18.245*iTime)*cos(11.323*iTime)*sin(4.313*iTime);',
      '  glitch *= glitch;',
      '  p.x += sin(p.y*19.1)*glitch*0.01;',
      '  p.x += sin(p.y*459.1)*glitch*glitch*0.02;',
      '  vec3 color = getPixel(p);',
      '  float lum = max(color.r, max(color.g, color.b));',
      '  return vec3(lum) * scanline;',
      '}',
      '',
      'void main(){',
      '  vec2 p = (gl_FragCoord.xy / iResolution.xy)*2.0-1.0;',
      '  p += p*dot(p,p)*0.22;',
      '  vec3 col = getScreen(p);',
      '  col = clamp((col - 0.5) * 1.85 + 0.5, 0.0, 1.0);',
      '  gl_FragColor = vec4(col, 1.0);',
      '}'
    ].join('\n');

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        if (window.console) console.warn('hero shader:', gl.getShaderInfoLog(s));
        return null;
      }
      return s;
    }

    var vs = compile(gl.VERTEX_SHADER, VS);
    var fs = compile(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return;

    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var aLoc = gl.getAttribLocation(prog, 'a');
    gl.enableVertexAttribArray(aLoc);
    gl.vertexAttribPointer(aLoc, 2, gl.FLOAT, false, 0, 0);

    var uRes = gl.getUniformLocation(prog, 'iResolution');
    var uTime = gl.getUniformLocation(prog, 'iTime');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      var r = canvas.getBoundingClientRect();
      var w = Math.max(1, Math.floor(r.width * dpr));
      var h = Math.max(1, Math.floor(r.height * dpr));
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
      }
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(uRes, canvas.width, canvas.height);
    }

    if (window.ResizeObserver) new ResizeObserver(resize).observe(canvas);
    window.addEventListener('resize', resize);
    resize();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      gl.uniform1f(uTime, 2.2);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      return;
    }
    var start = performance.now();
    (function frame(now) {
      gl.uniform1f(uTime, (now - start) / 1000);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      requestAnimationFrame(frame);
    })(start);
  })();

  // --- manifesto shader: fbm digit-grid content + bloom compositor ---------
  // Two-pass: pass A renders the animated digit field to a POT texture (mipped),
  // pass B is the bloom shader compositing three mip levels + the sharp base,
  // masked to a rounded rect. Monotone (grayscale in, grayscale out).
  (function matrixShader() {
    var canvas = document.querySelector('.manifesto__shader');
    if (!canvas) return;
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return;

    var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}';
    var FS = [
      'precision highp float;',
      'uniform vec2 iResolution;',
      'uniform float iTime;',
      'float time;',
      'float noise(vec2 p){ return sin(p.x*10.)*sin(p.y*(3.+sin(time/11.)))+.2; }',
      'mat2 rotate(float a){ return mat2(cos(a),-sin(a),sin(a),cos(a)); }',
      'float fbm(vec2 p){',
      '  p*=1.1; float f=0.; float amp=.5;',
      '  for(int i=0;i<3;i++){',
      '    mat2 m=rotate(time/50.*float(i*i));',
      '    f+=amp*noise(p); p=m*p; p*=2.; amp/=2.2;',
      '  }',
      '  return f;',
      '}',
      'float pattern(vec2 p, out vec2 q, out vec2 r){',
      '  q=vec2(fbm(p+vec2(1.)), fbm(rotate(.1*time)*p+vec2(1.)));',
      '  r=vec2(fbm(rotate(.1)*q+vec2(0.)), fbm(q+vec2(0.)));',
      '  return fbm(p+1.*r);',
      '}',
      'float digit(vec2 p){',
      '  vec2 grid=vec2(3.,1.)*15.;',
      '  vec2 s=floor(p*grid)/grid;',
      '  p=p*grid; vec2 q; vec2 r;',
      '  float intensity=pattern(s/10.,q,r)*1.3-0.03;',
      '  p=fract(p); p*=vec2(1.2,1.2);',
      '  float x=fract(p.x*5.); float y=fract((1.-p.y)*5.);',
      '  int i=int(floor((1.-p.y)*5.)); int j=int(floor(p.x*5.));',
      '  int n=(i-2)*(i-2)+(j-2)*(j-2);',
      '  float f=float(n)/16.;',
      '  float isOn=intensity-f>0.1?1.:0.;',
      '  return p.x<=1.&&p.y<=1.? isOn*(0.2+y*4./5.)*(0.75+x/4.):0.;',
      '}',
      'float onOff(float a,float b,float c){ return step(c, sin(iTime+a*cos(iTime*b))); }',
      'float displace(vec2 look){',
      '  float y=(look.y-mod(iTime/4.,1.));',
      '  float window=1./(1.+50.*y*y);',
      '  return sin(look.y*20.+iTime)/80.*onOff(4.,2.,.8)*(1.+cos(iTime*60.))*window;',
      '}',
      'vec3 getColor(vec2 p){',
      '  float bar=mod(p.y+time*20.,1.)<0.2?1.4:1.;',
      '  p.x+=displace(p);',
      '  float middle=digit(p);',
      '  float off=0.002; float sum=0.;',
      '  for(float i=-1.;i<2.;i+=1.){',
      '    for(float j=-1.;j<2.;j+=1.){ sum+=digit(p+vec2(off*i,off*j)); }',
      '  }',
      '  return vec3(0.9)*middle + sum/10.*vec3(1.)*bar;',   // monotone (white), was green
      '}',
      'void main(){',
      '  time=iTime/3.;',
      '  vec2 uv=gl_FragCoord.xy/iResolution.xy;',
      '  gl_FragColor=vec4(getColor(uv),1.);',
      '}'
    ].join('\n');

    // Pass B — bloom compositor: reads the content texture (iChannel0) at three
    // mip levels + the sharp base, masked to a rounded rect. Monotone (grayscale
    // content in, grayscale out). textureLod needs EXT_shader_texture_lod; if the
    // GPU lacks it we sample the base level (bloom degrades to a soft add).
    var lodExt = gl.getExtension('EXT_shader_texture_lod');
    var lodFn = lodExt ? 'texture2DLodEXT' : 'texture2D';
    var BLOOM_FS = [
      lodExt ? '#extension GL_EXT_shader_texture_lod : enable' : '',
      'precision highp float;',
      'uniform vec2 iResolution;',
      'uniform sampler2D iChannel0;',
      'float roundSquare(vec2 p, vec2 b, float r){ return length(max(abs(p)-b,0.0))-r; }',
      'float stdRS(vec2 uv, float r){ return roundSquare(uv-0.5, vec2(1.2,0.7)+r, 0.05); }',
      'void main(){',
      '  vec4 c = vec4(0.0);',
      '  vec2 uvC = gl_FragCoord.xy/iResolution.xy;',
      '  c += (' + lodFn + '(iChannel0, uvC, 3.) + ' + lodFn + '(iChannel0, uvC, 4.) + ' + lodFn + '(iChannel0, uvC, 5.))',
      '       * smoothstep(0., -0.004*20., stdRS(uvC, -0.02)) * 0.5;',
      '  if (uvC.x>0.&&uvC.x<1.&&uvC.y>0.&&uvC.y<1.) c += texture2D(iChannel0, uvC);',
      '  gl_FragColor = vec4(c.rgb, 1.0);',
      '}'
    ].join('\n');

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        if (window.console) console.warn('manifesto shader:', gl.getShaderInfoLog(s));
        return null;
      }
      return s;
    }
    function program(fsrc) {
      var vsh = compile(gl.VERTEX_SHADER, VS);
      var fsh = compile(gl.FRAGMENT_SHADER, fsrc);
      if (!vsh || !fsh) return null;
      var p = gl.createProgram();
      gl.attachShader(p, vsh); gl.attachShader(p, fsh); gl.linkProgram(p);
      if (!gl.getProgramParameter(p, gl.LINK_STATUS)) return null;
      return p;
    }

    var progA = program(FS);       // content
    var progB = program(BLOOM_FS); // bloom
    if (!progA || !progB) return;

    // fullscreen triangle, shared by both passes
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    function bindAttr(p) {
      var l = gl.getAttribLocation(p, 'a');
      gl.enableVertexAttribArray(l);
      gl.vertexAttribPointer(l, 2, gl.FLOAT, false, 0, 0);
    }

    // Content render target: POT so it can carry a mip chain for the bloom taps.
    var TEX = 1024, TEXH = 512;
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, TEX, TEXH, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    var fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, tex, 0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);

    var uAres = gl.getUniformLocation(progA, 'iResolution');
    var uAtime = gl.getUniformLocation(progA, 'iTime');
    var uBres = gl.getUniformLocation(progB, 'iResolution');
    var uBchan = gl.getUniformLocation(progB, 'iChannel0');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      var r = canvas.getBoundingClientRect();
      var w = Math.max(1, Math.floor(r.width * dpr));
      var h = Math.max(1, Math.floor(r.height * dpr));
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(canvas);
    window.addEventListener('resize', resize);
    resize();

    function render(t) {
      // Pass A: draw the digit content into the POT texture, then build mips.
      gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
      gl.viewport(0, 0, TEX, TEXH);
      gl.useProgram(progA); bindAttr(progA);
      gl.uniform2f(uAres, TEX, TEXH);
      gl.uniform1f(uAtime, t);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.generateMipmap(gl.TEXTURE_2D);

      // Pass B: composite bloom to the screen.
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.useProgram(progB); bindAttr(progB);
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.uniform1i(uBchan, 0);
      gl.uniform2f(uBres, canvas.width, canvas.height);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { render(3.0); return; }
    var start = performance.now();
    (function frame(now) {
      render((now - start) / 1000);
      requestAnimationFrame(frame);
    })(start);
  })();
})();
